import { defaultHttpClient } from '../../httpClient';
import type { ScreensReadResponse } from '../getScreens/types';

export type ScreensComponentResponse =
  ScreensReadResponse['components'][number];

interface GetScreenComponentParams {
  screenName: string;
  componentId: number;
  prevCarousel?: number;
}

export const getScreenComponent = ({
  screenName,
  componentId,
  prevCarousel,
}: GetScreenComponentParams) => {
  return defaultHttpClient
    .request<ScreensComponentResponse>({
      method: 'GET',
      url: `/api/v2/screens/${screenName}/components/${componentId}/`,
      params: {
        ...(prevCarousel != null && { prev_carousel: prevCarousel }),
      },
    })
    .then((result) => result.data);
};
